import type { IconDef } from '../types';

export const profileFilled: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M17.0459 14.7969C20.3304 14.7969 22.9999 17.4499 23 20.7148V22.5205C22.9999 23.3391 22.3352 23.9999 21.5117 24H2.48828C1.66482 23.9999 1.00013 23.3391 1 22.5205V20.7148C1.00007 19.1367 1.6149 17.6468 2.74609 16.5322C3.87736 15.4176 5.36636 14.7969 6.9541 14.7969H17.0459ZM12.4121 0C15.9646 0.000139951 18.8623 2.88076 18.8623 6.41211C18.8621 9.94332 15.9645 12.8231 12.4121 12.8232C8.85965 12.8232 5.96207 9.94341 5.96191 6.41211C5.96191 2.88068 8.85955 0 12.4121 0Z',
    },
  ],
};
